module.exports = __webpack_public_path__ + "static/oracleCloud-c621d00c09de1bfe7cc0dfe1b3fac71a.png";